import { ScrollLockCustomPlugin } from '@/plugins/scroll-lock/plugin'

export default {
  install: (app) => {
    const pluginInstance = new ScrollLockCustomPlugin() // Instantiate the class
    app.provide('scrollLockCustomPlugin', pluginInstance) // Provide the instance
  },
}
